import React, { memo } from "react";
import { Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const HeaderMain = styled("div")(({ theme }) => ({
  background:
    "linear-gradient(285.48deg, rgba(107, 107, 107, 0.2) 10.84%, rgba(187, 187, 187, 0.2) 89.16%)",
  border: "0.25px solid rgba(30, 39, 56, 0.2)",
  boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.08)",
  marginTop: "30px",
  padding: "10px 20px",
  "& .head_main": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      justifyContent: "inherit",
      paddingTop: "20px",
    },
  },
  "& .head_link button": {
    display: "flex",
    gap: "5px",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    textDecoration: "none",
    alignItems: "center",
    border: "none",
    background: "transparent",
    cursor: "pointer",
  },
  "& .head_contact h6": {
    fontFamily: theme.typography.fontFamily,
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "18px",
    lineHeight: "25px",
    textAlign: "center",
    color: "#0B0B0B",
  },
  "& .head_step": {
    width: "45px",
    height: "45px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
    [theme.breakpoints.down("md")]: {
      marginLeft: "auto",
    },
  },
  "& span.mobileSubText": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "13px",
    lineHeight: "18px",
    letterSpacing: "-0.01em",
    color: "rgba(11, 11, 11, 0.6)",
    marginLeft: "17px",
  },
  [theme.breakpoints.down("md")]: {
    marginTop: "10px",
    boxShadow: "none",
    border: "none",
    background: "transparent",
    justifyContent: "inherit",
    padding: "0",
    "& .backText": {
      display: "none",
    },
    "& .head_contact h6": {
      marginLeft: "15px",
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "20px",
      lineHeight: "27px",
      color: "#0B0B0B",
    },
    "& .head_link": {
      width: "35px",
      height: "35px",
      border: "1px solid #F3F3F3",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "30px",
      "& svg": {
        fontSize: "20px",
      },
    },
  },
}));

const DeliveryHead = ({
  Value,
  CenterText,
  BackLink,
  StepText,
  showBox = true,
  showLink = true,
  MobileMainText = "",
  MobileSubText = "",
  MobileMoreText = false,
  haveCallBack = false,
  CallBackFun = "",
}) => {
  const navigate = useNavigate();
  const value = Value ? Value : 25;
  const RedirLink = BackLink ? BackLink : "#";
  const HeaderText = CenterText ? CenterText : "";
  const StepCirText = StepText ? StepText : "-";
  const isMobile = window.innerWidth <= 767;
  const trailColor = isMobile ? "#E6E6E6" : "transparent";
  const MobileMainCon = MobileMainText ? MobileMainText : "";
  const MobileSubCon = MobileSubText ? MobileSubText : "";

  const ClickHandeler = () => {
    if (haveCallBack) {
      CallBackFun();
    } else {
      navigate(RedirLink);
    }
  };

  return (
    <>
      <Container maxWidth="lg">
        <HeaderMain className="breadcrumbs">
          <div className="head_main">
            <div className="head_link">
              {showLink ? (
                // <Link to={RedirLink}>
                //   <KeyboardBackspaceIcon />
                //   <span className="backText">Back</span>
                // </Link>
                <button onClick={ClickHandeler}>
                  <KeyboardBackspaceIcon />
                  <span className="backText">Back</span>
                </button>
              ) : (
                ""
              )}
            </div>
            <div className="head_contact">
              {isMobile && MobileMoreText ? null : <h6>{HeaderText}</h6>}
              {isMobile && MobileMoreText && MobileMainCon !== null ? (
                <h6>{MobileMainCon}</h6>
              ) : null}
              {isMobile && MobileSubText && MobileSubCon !== null ? (
                <span className="mobileSubText">{MobileSubCon}</span>
              ) : null}
            </div>
            <div className="head_step">
              {showBox ? (
                <CircularProgressbar
                  value={value}
                  text={StepCirText}
                  background
                  styles={buildStyles({
                    textSize: "20px",
                    pathTransitionDuration: 0.5,
                    pathColor: `#0B0B0B`,
                    textColor: `#0B0B0B`,

                    backgroundColor: `#FFFFFF`,
                    trailColor: trailColor,
                  })}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </HeaderMain>
      </Container>
    </>
  );
};

export default memo(DeliveryHead);
